import styled, { ITheme } from '../../../theme'
import is from 'typescript-styled-is'

const SubmitButton = styled.button<any>`
  cursor: pointer;
  border: 0px;
  margin: 0px;
  padding: ${({ size }) => (size ? 12 * size : 12)}px
    ${({ size }) => (size ? 30 * size : 30)}px;
  font-size: ${({ size }) => (size ? 1 * size : 1)}em;
  font-weight: 500;
  background-color: ${(props: ITheme) => props.theme.colors.primary};
  color: white;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  transition: background-color 0.15s ease-in-out;
  &:hover {
    background-color: #008735;
  }
  ${is('disable')`
    color: white;
    background-color: ${(props: ITheme) =>
    props.theme.colors.palette.lightGrey};
    
    &:hover {
      background-color: ${(props: ITheme) =>
    props.theme.colors.palette.lightGrey}; 
    }
  `}
  & > svg {
    float: left;
    margin-right: ${({ size }) => (size ? 5 * size : 5)}px;
  }

 

  ${is('cancel')`
      color: #000000;
      background-color: ${(props: ITheme) =>
        props.theme.colors.palette.lightGrey};
  &:hover {
    background-color: ${(props: ITheme) =>
      props.theme.colors.palette.pinkishGrey};
  }
  `}
`

export default SubmitButton
